import * as React from 'react';
import { DetailsList,  DetailsListLayoutMode,  SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { DatePicker  } from 'office-ui-fabric-react/lib/DatePicker';
import { Label } from 'office-ui-fabric-react/lib/Label';
import {CSVLink} from 'react-csv';

import './css/Site.css';
import './css/Fatture.css';
// import './css/mybillweb.css';

import { Config } from './Config.js';
import { Azioni } from './classi/Azioni.js';
import { Session } from './classi/Session.js';
import { Utils } from './classi/Utils.js';

const sessione = new Session();
const config = new Config();
const utils = new Utils();
const azioni = new Azioni();

const DayPickerStrings = config.getDayPickerStrings();
const firstDayOfWeek = config.getPrimoGiornoSettimana();

let _items: IDocument[] = [];
let _itemsDaEsportare: IDocument[] = [];

export class Fatture extends React.Component {

    constructor(){
        super();
        this.state = {
            fatture:[],
            fattureDaScaricare:[],
            errorMessage: '',
            id_cliente: false,
            showItemIndexInView: false,
            
            filterDataDa: new Date(),
            filterDataA: new Date(),
            visualizza:null,

            visualizzaFatture:'',
            visualizzaWarning:'nascosto',
            visualizzaLoading:'nascosto'
        };
        
        //this._onFormatDate = this._onFormatDate.bind(this);
        this._onChangeFiltraFatture = this._onChangeFiltraFatture.bind(this);
        this._onSelectDateDa = this._onSelectDateDa.bind(this);
        this._onSelectDateA = this._onSelectDateA.bind(this);
        this._filtra = this._filtra.bind(this);
        this._popolaFatture = this._popolaFatture.bind(this);
    }
                    
    componentDidMount() {
        
        let today = new Date();
        let mesi_ricerca = parseInt(utils.getObjInfoSocieta( 'MESI_RICERCA_FATTURA', 1 ), 10);
        let firstdaypreviosemonth = new Date( today.getFullYear() , today.getMonth()-mesi_ricerca, 1 , 0, 0, 0, 0);
        
        // #48347
        // se è abilitato il pagamento PAYPAL mostro le fatture degli ultimi 12 mesi
        if( utils.getObjInfoSocieta( 'ABILITA_PAYPAL' , 'NO' ) === 'SI' ){
            firstdaypreviosemonth = new Date( today.getFullYear() , today.getMonth()-12, 1 , 0, 0, 0, 0);
        }
        
        if( sessione.get('filterdatada') !== '' && sessione.get('filterdatada')!=='undefined' && sessione.get('filterdatada')!==null ){
            firstdaypreviosemonth = new Date(sessione.get('filterdatada'));
        }
        
        if( sessione.get('filterdataa') !== '' && sessione.get('filterdataa')!=='undefined' && sessione.get('filterdataa')!==null ){
           today = new Date(sessione.get('filterdataa'));
        }
        
        this.setState({id_cliente: sessione.get('id_cliente') , filterDataDa : firstdaypreviosemonth , filterDataA : today });
        
        setTimeout( function(){ this._popolaFatture(); }.bind(this) , 50 );
        
        utils.setBoxInfoCliente();
    }
    
    _popolaFatture()
    {
        let request = new Request( config.get("anagrafica_fatture"),{
            method: 'POST', mode: 'cors', credentials: "include", 
            body: JSON.stringify({
                data_da: utils._onFormatDate( this.state.filterDataDa ), 
                data_a: utils._onFormatDate( this.state.filterDataA ),
                id_cliente: sessione.get('id_cliente') 
            })
        });
        
        this.setState({visualizzaLoading:'loading centrato margin10' , visualizzaFatture:'nascosto'});
        
        fetch(request)
        .then(function(response){
            return response.json();
        }).then(function(result){
            
            utils.gestisciMessaggio( result );
            
            if (result.success) {
            
            
                this.setState({visualizzaLoading:'nascosto'});
            
                _items = [];
                _itemsDaEsportare = [];
                let visualizzaFatture= 'nascosto';
                let visualizzaWarning = 'warning centrato margin10';
                
                // regole di visualizzazione bottoni
                let visualizzaBtn = null;
                if( 'visualizza' in result.data ){  visualizzaBtn=result.data.visualizza; }
                
                // Elenco delle fatture
                if( 'fatture' in result.data )
                {
                    if ( result.data.fatture.length > 0) {
                        
                        visualizzaFatture= '';
                        visualizzaWarning = 'nascosto';
                        
                        for (let i = 0; i < result.data.fatture.length; i++) {
                            _items.push(result.data.fatture[i]);
                          
                            // pulisci datasource per esportare nel CSV solo i dati essenziali
                            let itemDaEsportare = utils.jsonCopy( result.data.fatture[i] );
                            
                            let consumi = 0;
                            if( itemDaEsportare.TIPO === 'G'){
                                let c1 = parseInt(itemDaEsportare.ENERGIA.toString().replace('.','') , 10 );
                                if(isNaN(c1) === true){consumi = 0;} else {consumi=c1;}
                            } else {
                                
                                // attenzione il numero 3256 arriva con separatore migliaia 3.256
                                // i kwh delle fasce arrivano come numeri interi senza decimali
                                let cF0 = parseInt(itemDaEsportare.ENERGIA_F0.toString().replace('.','').replace(',','.') , 10 );
                                let cF1 = parseInt(itemDaEsportare.ENERGIA_F1.toString().replace('.','').replace(',','.') , 10 );
                                let cF2 = parseInt(itemDaEsportare.ENERGIA_F2.toString().replace('.','').replace(',','.') , 10 );
                                let cF3 = parseInt(itemDaEsportare.ENERGIA_F3.toString().replace('.','').replace(',','.') , 10 );
                                let cP = parseInt(itemDaEsportare.ENERGIA_P.toString().replace('.','').replace(',','.') , 10 );
                                let cOP = parseInt(itemDaEsportare.ENERGIA_OP.toString().replace('.','').replace(',','.') , 10 );
                                
                                // visto con Bobo
                                // posso sommare F0+F1+F2+F3 oppure P+OP
                                if ( isNaN(cF0) === true && isNaN(cF1) === true && isNaN(cF2) === true && isNaN(cF3) === true ){
                                    if(isNaN(cP) === true){cP = 0;}
                                    if(isNaN(cOP) === true){cOP = 0;}
                                    consumi = cP + cOP;
                                } else {
                                    if(isNaN(cF0) === true){cF0 = 0;}
                                    if(isNaN(cF1) === true){cF1 = 0;}
                                    if(isNaN(cF2) === true){cF2 = 0;}
                                    if(isNaN(cF3) === true){cF3 = 0;}
                                    consumi = cF0 + cF1 + cF2 + cF3;
                                }
                                
                                
                            }
                            
                            if( utils.getObjInfoSocieta( 'ESPORTA_CONSUMI' , 'NO' ) === 'SI' ){
                                itemDaEsportare.CONSUMI = consumi;
                            }
                            
                            delete itemDaEsportare.IMPORTO_EXTRA;
                            delete itemDaEsportare.IMPORTO_REALE;
                            
                            delete itemDaEsportare.TOT_SITI;
                            delete itemDaEsportare.SPLIT;
                            delete itemDaEsportare.PATH;
                            // delete itemDaEsportare.DES_SITO;
                            delete itemDaEsportare.BOLLETTA_20;
                            delete itemDaEsportare.PATH_SINTESI;
                            delete itemDaEsportare.PATH_DETTAGLIO;
                            delete itemDaEsportare.PATH_BP;
                            delete itemDaEsportare.PATH_BZE;
                            delete itemDaEsportare.PATH_BZP;
                            delete itemDaEsportare.PATH_CERT;
                            
                            if( utils.getObjInfoSocieta( 'ESPORTA_CONSUMI' , 'NO' ) !== 'SI' ){
                                delete itemDaEsportare.ENERGIA_F1;
                                delete itemDaEsportare.ENERGIA_F2;
                                delete itemDaEsportare.ENERGIA_F3;
                                delete itemDaEsportare.ENERGIA_F0;
                                delete itemDaEsportare.ENERGIA_P;
                                delete itemDaEsportare.ENERGIA_OP;
                                
                                delete itemDaEsportare.PA_CODICE_CIG;
                            } else {
                                itemDaEsportare.ENERGIA_F1 = itemDaEsportare.ENERGIA_F1.toString().replace('.','');
                                itemDaEsportare.ENERGIA_F2 = itemDaEsportare.ENERGIA_F2.toString().replace('.','');
                                itemDaEsportare.ENERGIA_F3 = itemDaEsportare.ENERGIA_F3.toString().replace('.','');
                                itemDaEsportare.ENERGIA_F0 = itemDaEsportare.ENERGIA_F0.toString().replace('.','');
                                itemDaEsportare.ENERGIA_P = itemDaEsportare.ENERGIA_P.toString().replace('.','');
                                itemDaEsportare.ENERGIA_OP = itemDaEsportare.ENERGIA_OP.toString().replace('.','');
                            }
                            
                            delete itemDaEsportare.ENERGIA;
                            delete itemDaEsportare.ALIQUOTA_IVA;
                            delete itemDaEsportare.DETTAGLIO_BOLLETTA_20;
                            delete itemDaEsportare.ID_DOCUMENTO;
                            delete itemDaEsportare.TIPO;
                            delete itemDaEsportare.NEW_TOT_REALE;
                            
                            _itemsDaEsportare.push(itemDaEsportare);
                            
                        }
                    }

                    this.setState({fatture: _items , visualizzaFatture:visualizzaFatture, visualizzaWarning:visualizzaWarning , visualizza: visualizzaBtn , fattureDaScaricare:_itemsDaEsportare });
                }

                
            } else {
                this.setState({errorMessage: result.message , visualizzaFatture:'nascosto', visualizzaWarning:'warning centrato margin10' , visualizza:null});
            }
        }.bind(this) )
        
    }


    _filtra(){
        // console.log('Esegui Filtering ... '); 
        this._popolaFatture();
        
        document.getElementById( 'TextField81' ).value = '';
        
        utils.vaiAId( 'elencofatturelista' );
    }
    
    _onChangeFiltraFatture(event) {

        this.setState({ fatture: event.target.value ? 
            _items.filter(i =>  ( i.SCADENZA.toLowerCase().indexOf(event.target.value.toLowerCase() ) >-1) || 
                                (i.SITO.toLowerCase().indexOf(event.target.value.toLowerCase() )>-1) || 
                                (i.NUMERO_DOCUMENTO.toLowerCase().indexOf(event.target.value.toLowerCase() )  > -1) 
                         ) :  _items });
    };
    
    _onSelectDateDa ( date: Date | null | undefined) {
        this.setState({ filterDataDa: date });
        sessione.set('filterdatada', date );
    };
    
    _onSelectDateA ( date: Date | null | undefined) {
        this.setState({ filterDataA: date });
        sessione.set('filterdataa', date );
    };
    
    
    render() {
        
        const { filterDataDa , filterDataA , visualizza } = this.state;

        return (
        <div id="inner-container">
            <Label className='ms-fontSize-xxl titolo-pagina'>Fatture<span id='boxdettagliocliente'></span></Label>

            <div id='filtri'>
                <div className='boxsearch'>
                <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Ricerca per data</span></label>
                
                <div id='ricercada'>

                    <DatePicker id='filtradatada'
                        label='Da Data'
                        firstDayOfWeek={firstDayOfWeek}
                        strings={DayPickerStrings}
                        placeholder="Seleziona una data"
                        dateFormat="DD-MM-YYYY"
                        formatDate={utils._onFormatDate}
                        locale='it'
                        value={filterDataDa}
                        onSelectDate={this._onSelectDateDa}
                        className='ms-font-m-plus'
                     />

                </div>
                
                <div id='ricercaa'>

                    <DatePicker id='filtradataa'
                        label='A Data'
                        firstDayOfWeek={firstDayOfWeek}
                        strings={DayPickerStrings}
                        placeholder="Seleziona una data"
                        dateFormat="DD-MM-YYYY"
                        formatDate={utils._onFormatDate}
                        locale='it'
                        value={filterDataA}
                        onSelectDate={this._onSelectDateA}
                        className='ms-font-m-plus'
                     />

                </div>
                
                <div>
                <DefaultButton
                    primary={true}
                    data-automation-id="test"
                    text="Cerca"
                    onClick={this._filtra}
                    allowDisabledFocus={true}
                  />
                </div>
                </div>

                <div className='boxsearch'>
                <label className='ms-bgColor-themePrimary ms-font-m-plus'><span>Filtra per FATTURA / POD / SCADENZA</span></label>
                
                <div id='ricercapod'>
                    <div className="ms-ComboBoxCustomStyledExample">
                        Ricerca <br/>

                        <div className="ms-TextField-wrapper wrapper_df60a678">
                            <div className="ms-TextField-fieldGroup fieldGroup_df60a678">
                                <input type="text" onChange={this._onChangeFiltraFatture} id="TextField81" className="ms-TextField-field field_df60a678 ms-font-m" />
                            </div>
                        </div>

                    </div>
                </div>


                </div>
             </div>
             
             
            <div id="warning" className={this.state.visualizzaWarning}>Nessuna Fattura disponibile per il periodo selezionato</div> 
            
            <div id="loading" className={this.state.visualizzaLoading}>... Ricerca fatture in corso ... </div>

            <div id="elencofatture" className={ "DetailListContainer "+this.state.visualizzaFatture} >
            
                <div id="scarico" >
                <CSVLink data={this.state.fattureDaScaricare} separator={";"} filename={"elenco_fatture.csv"} className="btn btn-primary" target="_blank" ><div className="ms-BrandIcon--icon96 ms-BrandIcon--excel"></div><span>Scarica CSV</span></CSVLink>
                </div>

                <div id="elencofatturelista" >
                <DetailsList
                    items={this.state.fatture}
                    columns={ azioni.restituisciColonneFatture( visualizza ) }
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.fixedColumns}
                    selectionMode={SelectionMode.none}
                    selectionPreservedOnEmptyClick={true}
                    onItemInvoked={this._onItemInvoked}
                  />
                  </div>
            </div>

            <div id="boxdialogo"></div>

        </div>
        );
    }
};

export default Fatture;


// WEBPACK FOOTER //
// ./src/AcComponents/Fatture.js